import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors, ScreenDepth } from "@ryde/theme";

/** Client-side base-tile selector — the MapLibre twin of the Leaflet `LayersControl` (top-right). */
export const MapLibreLayerControlStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "maplibre-layer-control",
})`
  position: absolute;
  top: 10px;
  /* Stay top-right in RTL (Hebrew) too — the stylis RTL plugin flips right→left otherwise. */
  right: 10px /* @noflip */;
  z-index: ${ScreenDepth.MAP_MAPLIBRE_LAYER_CONTROL};
  background: ${rydeColors.white};
  border-radius: 4px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
  color: ${rydeColors.black};
  overflow: hidden;
`;

export const MapLibreLayerToggleStyled = styled.button.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "maplibre-layer-control-toggle",
  },
)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${greyMui._600};
  cursor: pointer;

  &:hover {
    color: ${rydeColors.black};
    background: ${greyMui._100};
  }
`;

export const MapLibreLayerOptionsStyled = styled.ul.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "maplibre-layer-control-options",
})`
  list-style: none;
  margin: 0;
  padding: 6px 12px;
  min-width: 120px;
`;

export const MapLibreLayerOptionStyled = styled.label.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "maplibre-layer-control-option",
})`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 0;
  font-size: 13px;
  line-height: 1.4;
  cursor: pointer;
  white-space: nowrap;

  input {
    margin: 0;
    cursor: pointer;
  }
`;
